import { Card, CardContent, Typography, Box, Link, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { motion } from "motion/react";
import { useState } from "react";

interface ContactCardProps {
  label: string;
  value: string;
  href?: string;
  icon: React.ReactNode;
  isCopyable?: boolean;
}

export default function ContactCard({ label, value, href, icon, isCopyable }: ContactCardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <motion.div
      whileHover={{ scale: 1.03, boxShadow: "0px 8px 20px rgba(0,0,0,0.15)" }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      <Card sx={{ p: 2, minWidth: 250, position: 'relative' }}>
        <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box>{icon}</Box>
          <Box flex={1}>
            <Typography variant="subtitle2" color="text.secondary">{label}</Typography>
            {href ? (
              <Link href={href} target="_blank" underline="hover" variant="body1">
                {value}
              </Link>
            ) : (
              <Typography variant="body1">{value}</Typography>
            )}
          </Box>

          {isCopyable && (
            <Tooltip title={copied ? "Copied!" : "Copy"}>
              <IconButton size="small" onClick={handleCopy}>
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}
